module.exports = __webpack_public_path__ + "img/rot08.604f1886.jpg";